module.exports = __webpack_public_path__ + "img/img8.4065f3b5.png";